// extracted by mini-css-extract-plugin
export var linkhover = "index-module--linkhover--INekv";
export var SidebarReviewRotator = "index-module--SidebarReviewRotator--o3cJ7";
export var review = "index-module--review--vfurO";
export var rating = "index-module--rating--RWhPR";
export var star = "index-module--star--tFU-K";
export var blurb = "index-module--blurb--laYFV";
export var content = "index-module--content--1gaKy";
export var name = "index-module--name--EbhRM";
export var location = "index-module--location--t99Qb";